export default class Dashboard {
  /**
   * The HTML element of the cards.
   */
  private $cards: NodeListOf<HTMLElement>;

  /**
   * Initializes the dashboard.
   */
  constructor() {
    this.$cards = document.querySelectorAll('.tc-dashboard .card');

    [].slice.call(this.$cards).forEach(($card) => this.processCard($card));
  }

  private processCard($card: HTMLElement): void {
    if ($card.querySelector('.tc-dashboard__progress')) {
      const $progress = $card.querySelector('.tc-dashboard__progress');

      // Create the chart.
      var $graph = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

      // Calculate a few values.
      const size = 68;

      $graph.setAttribute('viewBox', `0 0 ${size} ${size}`);
      $graph.setAttribute('height', `${size}`);
      $graph.setAttribute('width', `${size}`);

      const stroke = 8;
      const radius = (size - stroke) / 2;
      const cx = (radius + (stroke / 2)) + (size - (radius * 2 + stroke)) / 2;
      const cy = (radius + (stroke / 2)) + (size - (radius * 2 + stroke)) / 2;

      const circumference = 2 * Math.PI * radius;
      const percentage = parseInt($progress.getAttribute('data-percentage'));

      // Add the track.
      var $track = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      $track.setAttribute('class', 'tc-dashboard__progress__track');
      $track.setAttribute('cx', `${cx}`);
      $track.setAttribute('cy', `${cy}`);
      $track.setAttribute('r', `${radius}`);
      $track.setAttribute('fill', 'transparent');
      $track.setAttribute('stroke-width', `${stroke}`);
      $graph.appendChild($track);

      // Add the segment.
      var $segment = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      $segment.setAttribute('class', 'tc-dashboard__progress__segment');
      $segment.setAttribute('cx', `${cx}`);
      $segment.setAttribute('cy', `${cy}`);
      $segment.setAttribute('r', `${radius}`);
      $segment.setAttribute('fill', 'transparent');
      $segment.setAttribute('stroke-width', `${stroke}`);
      $segment.setAttribute('stroke-linecap', 'round');
      $segment.setAttribute('stroke-dasharray', `${circumference}`);
      $segment.setAttribute('stroke-dashoffset', `${circumference - ((percentage / 100) * circumference)}`);
      $segment.setAttribute('transform', `rotate(-90, ${cx}, ${cy})`);
      $graph.appendChild($segment);

      $progress.appendChild($graph);

      // Add the label.
      const $label = document.createElement('div');

      $label.classList.add('tc-dashboard__progress__label');
      $label.innerHTML = `${percentage}%`;

      $progress.appendChild($label);
    }
  }
}
